export const GET_WARRANTY = 'GET_WARRANTY';
export const SET_WARRANTY = 'SET_WARRANTY';
export const SET_ADDRESS = 'SET_ADDRESS';
export const SET_EXISTING_WARRANTY = 'SET_EXISTING_WARRANTY';